import { Fragment, useCallback } from 'react';
import BaseGlyphSeries from "./private/BaseGlyphSeries.js";
import defaultRenderGlyph from "./private/defaultRenderGlyph.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function GlyphSeries(_ref) {
  let {
    renderGlyph = defaultRenderGlyph,
    ...props
  } = _ref;
  const renderGlyphs = useCallback(_ref2 => {
    let {
      glyphs,
      onPointerMove,
      onPointerOut,
      onPointerUp,
      onFocus,
      onBlur
    } = _ref2;
    return glyphs.map(glyph => /*#__PURE__*/_jsx(Fragment, {
      children: renderGlyph({
        ...glyph,
        onPointerMove,
        onPointerOut,
        onPointerUp,
        onFocus,
        onBlur
      })
    }, glyph.key));
  }, [renderGlyph]);
  return /*#__PURE__*/_jsx(BaseGlyphSeries, {
    ...props,
    renderGlyphs: renderGlyphs
  });
}